import styled from 'styled-components'

const Metadata = styled.div`
  display: flex;
  flex-direction: row;
  color: #737373;
  font-size: 14px;
  align-items: center;
  flex-wrap: wrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-weight: 300;
  gap: 8px;

  .mobile-hidden {
    @media screen and (max-width: 767px) {
      display: none;
    } 
  }

  .mobile-show {
    display: none;

    @media screen and (max-width: 767px) {
      display: initial;
    } 
  }
`

export default Metadata